import { HStack, Image, StackProps, Text, VStack } from "@chakra-ui/react";
import { BestSellerInterface } from "../../constants/Supplier";
import { useBgHover } from "../../themes/colors";
import { useNavigate } from "react-router-dom";

interface Props extends StackProps {
  data: BestSellerInterface | undefined;
}

export const BestSellerCard = ({ data, ...rest }: Props) => {
  const bgHover = useBgHover();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(
      `/reseller/search/product/${data?.product_id}`
    );
  };

  return (
    <HStack
      p={1}
      borderRadius={"md"}
      cursor={"pointer"}
      _hover={{ bg: bgHover }}
      onClick={handleClick}
      {...rest}
    >
      <Image
        className="ratio-1-1"
        w={["100px", "100px", null, "70px"]}
        src={
          data?.main_picture
            ? `${process.env.REACT_APP_MEDIA_URL}${data?.main_picture}`
            : ""
        }
        alt={data?.name || "Product Image"}
        fallbackSrc="/assets/svg/illustration_empty.svg"
        objectFit={"cover"}
        borderRadius={"md"}
      />

      <VStack gap={[0, null, 0.5]} align={"stretch"}>
        <Text
          textStyle={"b-reg-sb"}
          noOfLines={1}
          textOverflow={"ellipsis"}
          maxW={["130px", null, "140px"]}
        >
          {data?.name}
        </Text>
        <Text
          fontSize={[10, null, 12]}
          variant={"secondary"}
        >{`${data?.sold} Terjual`}</Text>
      </VStack>
    </HStack>
  );
};
